import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { T } from '../../../../../Translations';
import { ShareBy, ShareType } from '../Stores/ShareStore/Types';

interface Props {
  collectionId: number;
  isPublished: boolean;
  isPublishing: boolean;
  shareBy: ShareBy;
  shareType: ShareType;
  returnPath?: string;
}

const NextButton: React.FC<Props> = ({
  collectionId,
  isPublished,
  isPublishing,
  shareBy,
  shareType,
  returnPath,
}) => {
  const navigate = useNavigate();

  const isDisabled = !isPublished || isPublishing;

  const handleClick = () => {
    if (isPublished && !isPublishing) {
      const params = new URLSearchParams();
      params.set('shareBy', shareBy);
      params.set('shareType', shareType);
      if (returnPath) {
        params.set('returnPath', returnPath);
      }
      navigate(`/learning_collections/${collectionId}/share?${params.toString()}`);
    }
  };

  return (
    <button
      className={`px-8 py-2.5 rounded-md transition-colors font-semibold text-sm leading-5 tracking-normal h-10 ${
        isDisabled
          ? 'bg-muted text-muted-foreground cursor-not-allowed'
          : 'bg-primary text-primary-foreground hover:bg-primary/90'
      }`}
      disabled={isDisabled}
      onClick={handleClick}
      data-intercom-target="share-overlay-next-button"
    >
      <T kind="Next" />
    </button>
  );
};

export default NextButton;
